<template>
  <tr>
    <td class="table-ranking" v-html="hero.rank" />
    <td class="table-name">
      <p v-html="$t(`${hero.heroId}`, null, 'localeCharacter')" />

      <!-- NOTE:べレト,ベレスだけ表示を追加 ここから-->
      <p v-if="hero.heroId === '115001'" v-html="$t('115002', null, 'localeCharacter')"/>
      <p v-if="hero.heroId === '115003'" v-html="$t('115004', null, 'localeCharacter')"/>

      <div class="table-series-name">
        <p v-for="(item, i) in series" :key="i">
          <span v-html="seriesName(item)" />
        </p>
      </div>
    </td>
    <td class="table-vote" v-html="count(hero.voteCount)" />
  </tr>
</template>

<script>
import { localeFigure } from '@constants'
import localeCharacter from '@locales/character'
import localeSeries from '@locales/series'

export default {
  name: 'table-item',
  $messages: { localeCharacter, localeSeries },
  props: {
    hero: {
      type: Object,
      required: true,
    }
  },
  computed: {
    series() {
      const series = this.hero.seriesIds.filter(s => s.id).map(s => s.id)
      return [...new Set(series)]
    }
  },
  methods: {
    seriesName(id){
      return this.$t(`game${id}.title`, null, 'localeSeries')
    },
    count(count) {
      return localeFigure(count, this.$route.params.lang)
    }
  },
}
</script>

<style lang="scss" scoped>
tr::after {
  position: absolute;
  left: 0px;
  display: block;
  width: 640px;
  height: 2px;
  background: url(#{$img-path}lin_list.png) no-repeat;
  content: '';
}
td {
  padding: 20px;
  vertical-align: middle;
  &.table-ranking {
    box-sizing: border-box;
    width: 100px;
    font-size: $fs-xlarge;
    text-align: center;
  }
  &.table-name {
    box-sizing: border-box;
    width: auto;
    font-size: $fs-xlarge;
    text-align: left;
  }
  &.table-vote {
    box-sizing: border-box;
    width: 140px;
    font-size: $fs-xlarge;
  }
  .table-series-name {
    color: #878787;
    font-size: $fs-base;
  }
}

</style>
